export const POLICIES = [
{
id:'terms',
title:'Terms & Conditions',
icon:'📜',
subtitle:'Rules, responsibilities and platform usage'
},

{
id:'privacy',
title:'Privacy Policy',
icon:'🔒',
subtitle:'How NESSEFY collects and protects data'
},

{
id:'cookie',
title:'Cookie Policy',
icon:'🍪',
subtitle:'Cookies, sessions and tracking'
},

{
id:'disclaimer',
title:'Disclaimer',
icon:'⚠️',
subtitle:'Platform limitations and legal notice'
}
];